<div class="expiring-password-step">
  <p class="authentication__right__card_title">
    {{ 'LOGIN.AUTH.EXPIRING_PASSWORD.TITLE' | translate }}
  </p>

  <div class="authentication__right__card__field" fxLayout="column" fxLayoutAlign="center stretch">
    <div
      class="authentication__right__card_description authentication__right__card_description--only-text"
      [innerHTML]="
        'LOGIN.AUTH.EXPIRING_PASSWORD.DESCRIPTION'
          | translate
            : {
                daysToExpire: extraAuthInfo.passwordStatus.daysToExpires + 1
              }
      "
    ></div>
  </div>

  <button
    class="authentication__right__card_next mt-27"
    mat-raised-button
    (click)="resetPassword.next()"
    [disabled]="isLoading"
  >
    {{ 'LOGIN.AUTH.EXPIRING_PASSWORD.RESET_NOW' | translate }}
  </button>

  <div class="authentication__right__card__divisor" fxLayout="row" fxLayoutAlign="stretch center">
    <div class="authentication__right__card__divisor-border"></div>
    <p class="authentication__right__card__divisor-text">{{ 'LOGIN.AUTH.OR' | translate }}</p>
  </div>

  <button
    class="authentication__right__card_next authentication__right__card_next--white"
    mat-raised-button
    (click)="authWithoutResetPassword.next()"
    [disabled]="isLoading"
  >
    {{ 'LOGIN.AUTH.EXPIRING_PASSWORD.CONTINUE_WITHOUT_RESET' | translate }}
  </button>
</div>
